// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bg-comprehensive[data-v-486d6c18]{background-image:url(https://stories.rostrum.agency/air/comprehensive-conversations-campaign-manifesto/assets/b3deZtw3Oj/air-manifesto-2560x1440.webp);background-size:cover}[data-v-486d6c18] .v-text-field__slot textarea{margin-top:30px!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
